'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        activeCell: {
            type: String,
            kComposite: 'activeCell'
        },
        name: {
            type: String,
            kComposite: 'name'
        },
        columns: {
            type: Array,
            kComposite: 'columns'
        },
        dataSource: {
            type: Object | Array,
            kComposite: 'dataSource'
        },
        dataSourceRef: {
            type: String,
            kComposite: 'dataSourceRef'
        },
        filterColumns: {
            type: Array,
            kComposite: 'filter.columns'
        },
        filterRef: {
            type: String,
            kComposite: 'filter.ref'
        },
        frozenColumns: {
            type: Number,
            kComposite: 'frozenColumns'
        },
        frozenRows: {
            type: Number,
            kComposite: 'frozenRows'
        },
        mergedCells: {
            type: Array,
            kComposite: 'mergedCells'
        },
        rows: {
            type: Array,
            kComposite: 'rows'
        },
        selection: {
            type: String,
            kComposite: 'selection'
        },
        showGridLines: {
            type: Boolean,
            kComposite: 'showGridLines'
        },
        sortColumns: {
            type: Array,
            kComposite: 'sort.columns'
        },
        sortRef: {
            type: String,
            kComposite: 'sort.ref'
        }
    }
};